import { render } from "./TopicList.vue?vue&type=template&id=0de79260"
import script from "./TopicList.vue?vue&type=script&lang=js"
export * from "./TopicList.vue?vue&type=script&lang=js"

import "./TopicList.vue?vue&type=style&index=0&id=0de79260&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__